import { useEffect, useState } from "react";
import api, { errorMessage } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { toast } from "sonner";

// The nine categories of the CDC: their code never changes; equipment:manage_all renames them or stops offering one (existing devices keep it).
export default function CategoriesDialog({ open, onOpenChange }) {
  const [items, setItems] = useState([]);
  const [labels, setLabels] = useState({});
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    if (!open) return;
    api.get("/equipment/categories").then(({ data }) => { setItems(data.items); setLabels(Object.fromEntries(data.items.map((c) => [c.code, c.label]))); })
      .catch((e) => toast.error(errorMessage(e, "Impossible de charger les catégories.")));
  }, [open]);

  const save = async (category, changes) => {
    setBusy(category.code);
    try {
      const { data } = await api.patch(`/equipment/categories/${category.code}`, { ...changes, expected_version: category.version });
      setItems(data.items);
      setLabels(Object.fromEntries(data.items.map((c) => [c.code, c.label])));
      toast.success("Catégorie enregistrée");
    } catch (e) {
      toast.error(errorMessage(e, "Enregistrement impossible. Réessayez."));
    } finally {
      setBusy(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="equipment-categories-dialog">
        <DialogHeader>
          <DialogTitle>Catégories de matériel</DialogTitle>
          <DialogDescription>Renommez une catégorie ou cessez de la proposer : le matériel déjà recensé la garde.</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2">
          {items.map((c) => {
            const label = (labels[c.code] || "").trim();
            return (
              <li key={c.code} className="flex items-center gap-2">
                <Input aria-label={`Nom de la catégorie ${c.label}`} className="text-base md:text-sm" maxLength={60} value={labels[c.code] || ""}
                  onChange={(e) => setLabels((l) => ({ ...l, [c.code]: e.target.value }))} data-testid={`equipment-category-${c.code}`} />
                <Button variant="outline" size="sm" className="h-10" disabled={busy === c.code || !label || label === c.label}
                  onClick={() => save(c, { label })}>Renommer</Button>
                <Switch checked={c.active} disabled={busy === c.code} aria-label={`Proposer ${c.label}`} onCheckedChange={(v) => save(c, { active: v })} />
              </li>
            );
          })}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
